<template>
<Header style="position:fixed; width:100%; z-index:10;">
  <Menu theme="primary" mode="horizontal" width="auto">
    <div class="header-brand">
      <router-link to="/" class="logo"></router-link>
    </div>
    <div class="header-nav">
      <MenuItem name="1" v-if="$store.state.account.copy" to="/account/select">
        {{$store.state.account.copy.name}}
      </MenuItem>
      <Submenu name="2" v-if="$store.state.auth.user">
        <template slot="title">
          <Avatar icon="md-person" size="small"/>
          <span style="margin-left:4px;">{{$store.state.auth.user.fullName}}</span>
        </template>
        <MenuItem name="2-1" v-if="$store.state.auth.user.role=='admin'"><router-link to="/user/new">Create User</router-link></MenuItem>
        <MenuItem name="2-1" v-if="$store.state.auth.user.role=='admin'"><router-link to="/user/list">User List</router-link></MenuItem>
        <MenuItem name="2-2" v-if="$store.state.auth.user.role=='admin'"><router-link to="/account/new">Create Account</router-link></MenuItem>
        <MenuItem name="2-3" ><router-link to="/account/select">Account List</router-link></MenuItem>
        <MenuItem name="2-4" v-if="$store.state.auth.user.role=='admin'"><router-link to="/app-settings">App Settings</router-link></MenuItem>
        <MenuItem name="2-5"  divided="true"><router-link to="/logout">Logout</router-link></MenuItem>
      </Submenu>
    </div>
  </Menu>
</Header>
</template>

<script>
export default {
  created() {
    console.log(this.$store.state.auth);
  }
};
</script>

<style lang="less" scoped>
@import '~iview/src/styles/index.less';
@import '../../less/variables.less';
@import '../../less/helpers.less';

.ivu-layout-header{
  background: @background-color-base;
  border-bottom: 0.5px solid @border-color-split;

  .ivu-menu-horizontal {
    height: 64px;
    line-height: 64px;
  }

  .ivu-menu-primary{
    background: transparent;
  }
  .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-item, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-submenu{
    color: @text-color;
  }
  .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-primary.ivu-menu-horizontal .ivu-menu-submenu:hover{
    background: darken(@background-color-base, 2.5%);
  }
  .ivu-menu-item{
    font-size: @font-size-base !important;
    a{
      color: @text-color;
      display: block;
    }
  }
  .ivu-menu-horizontal .ivu-menu-submenu .ivu-select-dropdown .ivu-menu-item{
    padding: 8px 16px;
    line-height: @line-height-base;
  }
  .ivu-menu-submenu-title > i, .ivu-menu-submenu-title span > i {
      margin-right: 0px;
  }
  .header-brand{
    display: inline-block;
    height: 64px;
    .logo{
      width: 118px;
      display: block;
      height: 64px;
      background-position: center;
      .image-2x('/img/logo.png', 118px, 22px);
    }
  }
  .header-nav{
    float: right;
  }
}
</style>
